import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { RecertFormData } from 'components/Assessments/RecertAssessment/types/RecertFormData'
import { RecertFormField } from 'components/Assessments/RecertAssessment/types/RecertFormField'
import { RecertAssessmentQuestionnaireItem } from 'components/Assessments/RecertAssessment/types/questionnaire'
import { AdapterOptions, FlatAnswerMutation } from 'components/Assessments/adapters/types'
import { BaseSubsectionAdapter } from '../../../../../adapters/BaseSubsectionAdapter'
import { getAnswerValuesFromItems } from 'components/Assessments/helpers'

/**
 * Lines/Drains subsection adapter
 * Handles lines and drains assessment (1 field - simplest subsection)
 */
export class LinesDrainsAdapter extends BaseSubsectionAdapter<RecertFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<RecertFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    // Single field extraction
    const systemSummary = getAnswerValuesFromItems(
      flatAnswersArray,
      RecertAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_LINES_DRAINS_SYSTEM_SUMMARY
    )?.at(0)

    return {
      [RecertFormField.LINES_DRAINS_SYSTEM_SUMMARY]: systemSummary
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = []

    if (this.formDataFieldExists(RecertFormField.LINES_DRAINS_SYSTEM_SUMMARY)) {
      mutations.push({
        linkId: RecertAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_LINES_DRAINS_SYSTEM_SUMMARY,
        value: this.getFormDataField(RecertFormField.LINES_DRAINS_SYSTEM_SUMMARY)
      })
    }

    return mutations
  }
}
